import "core-js/modules/es.array.find";
import "core-js/modules/es.array.some";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { questionnaireResultUserDetail } from "@/api/gmtool/packageCode";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      questionResult: []
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                questionnaireResultUserDetail({
                  id: data.id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this.questionResult = res.data.answers || [];
                  }
                }).catch(function (err) {
                  console.error("获取详情失败:", err);
                });
                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * 判断当前选项是否被玩家勾选 (用 k 匹配 id)
     * @param {Array} answerList 玩家提交的答案数组，形如 [{k: 5, v: "xx"}]
     * @param {Number} optionId 当前遍历的选项 id
     */
    isOptionChecked: function isOptionChecked(answerList, optionId) {
      if (!Array.isArray(answerList)) return false;
      return answerList.some(function (ans) {
        return ans.k === optionId;
      });
    },

    /**
     * 获取已选中选项关联的输入框文本内容 (获取 v 的值)
     * @param {Array} answerList 玩家提交的答案数组
     * @param {Number} optionId 当前遍历的选项 id
     */
    getOptionInputValue: function getOptionInputValue(answerList, optionId) {
      if (!Array.isArray(answerList)) return '';
      var matchedAnswer = answerList.find(function (ans) {
        return ans.k === optionId;
      });
      return matchedAnswer ? matchedAnswer.v : '';
    }
  }
};